import React, { useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import image from './logo-white.svg';
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './header.css';
import { FaSearch } from 'react-icons/fa';
import { FaBars } from 'react-icons/fa';
import LoginMenu from '../authentication/LoginMenu';
import { Link } from 'react-router-dom';

const Header = (props: any) => {
  const keywordInputRef = useRef<HTMLInputElement>(null);
  const handleSearch = (event: any) => {
    event.preventDefault();
    const keyword = keywordInputRef.current!.value;
    if (keyword.trim().length === 0) {
      return;
    } else {
      window.location.href = `/search?q=${encodeURIComponent(keyword)}`;
    }
  };
  return (
    <Container className="header-container">
      <Container className="image-container">
        <div className="hamburger-menu-bars" onClick={props.toggleOpen}>
          <FaBars size={40} />
        </div>
        <Link to="/">
          <img title="LIFETIME DATAVAULT" className="header-image w-100" src={image} />
        </Link>
      </Container>
      <Container className="header-search-container">
        <Form className="header-search-form" action="/search" onSubmit={handleSearch}>
          <Form.Control
            className="header-search"
            type="search"
            placeholder="What are you looking for?"
            name="q"
            ref={keywordInputRef}
          />
          <Button className="header-submit-button" variant="primary" type="submit">
            <FaSearch />
          </Button>
        </Form>
      </Container>
      <LoginMenu />
    </Container>
  );
};

export default Header;
